import { useEffect } from 'react'
import dynamic from 'next/dynamic'
import useSeti from '@/hooks/useSeti'
import useBootstrapData from '@/hooks/useBootstrapData'
import analytics from '@/shared-utils/analytics'
import { useRouter } from 'next/router'
import pclnExperimentation from '@pcln/experimentation'

const PackagesDesktop = dynamic(() => import('./Desktop'))
const PackagesMobile = dynamic(() => import('./Mobile'))

function Packages() {
  useSeti('AA_PACKAGES_LP') // AA Test: Unconditional firing and no visual changes
  const { query } = useRouter()
  const { isMobile = false } = useBootstrapData()
  const isFromPkgError =
    typeof query['redirect-source'] === 'string' &&
    query['redirect-source'].toLowerCase() === 'error'
  useEffect(() => {
    analytics.fireGA4Event({
      event: 'page_view',
      attributes: {
        page_name: 'landing',
        page_desc: 'bundle'
      }
    })
  }, [])

  useEffect(() => {
    if (isFromPkgError) {
      pclnExperimentation.fireImpression('PKG_ERROR_REDIRECT_TO_LANDING') // fire impression here if coming from pkg-search as error
      analytics.fireGA4Event({
        event: 'display',
        attributes: {
          type: 'pkg_landing_search_redirect_error',
          page_name: 'landing',
          product_name: 'bundle'
        }
      })
    }
  }, [isFromPkgError])

  return isMobile ? <PackagesMobile /> : <PackagesDesktop />
}

export default Packages
